import { css } from "styled-components";

export const CPRIMARY = css`
  ${`#212529`}
`;

export const PVOGO = css`
  ${`#6728FF`}
`;

export const RED = css`
  ${`#E02020`}
`;

export const YELLOW = css`
  ${`#FDD933`}
`;

export const GREEN = css`
  ${`#50D46D`}
`;

export const BLUE = css`
  ${`#1C81EF`}
`;

export const WHITE = css`
  ${`#fff`}
`;

export const BLACK = css`
  ${`#252525`}
`;

export const REALBLACK = css`
  ${`#181818`}
`;

export const GF8F9FA = css`
  ${`#F8F9FA`}
`;

export const GF1F3F5 = css`
  ${`#F1F3F5`}
`;

export const GDFE5E8 = css`
  ${`#DFE5E8`}
`;

// 이전 #CED3DA
export const GCCD4D8 = css`
  ${`#CCD4D8`}
`;

export const GACB5BD = css`
  ${`#ACB5BD`}
`;

// 이전 #868E96
export const G858F9C = css`
  ${`#858F9C`}
`;

export const G646F7C = css`
  ${`#646F7C`}
`;

// 이전 #485057
export const G4A5561 = css`
  ${`#4A5561`}
`;

export const G343A40 = css`
  ${`#343A40`}
`;

export const BEDE9FF = css`
  ${`#EDE9FF`}
`;

export const BDDD7FF = css`
  ${`#DDD7FF`}
`;

export const BC9BEFF = css`
  ${`#C9BEFF`}
`;

export const BBAA9FF = css`
  ${`#BAA9FF`}
`;

export const BA693FF = css`
  ${`#A693FF`}
`;

export const B977EFF = css`
  ${`#977EFF`}
`;

export const B8768FF = css`
  ${`#8768FF`}
`;

export const B6E42FF = css`
  ${`#6E42FF`}
`;

export const C444 = css`
  ${`#444`}
`;
